import React from 'react';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import Card from '../../../../components/Card';

import './style.scss';

export interface NodeAnnualReportCardProps {
  title: string;
  link: string;
  image: React.ReactNode;
}

const NodeAnnualReportCard: React.FC<NodeAnnualReportCardProps> = (props) => {
  const { title, link, image } = props;

  return (
    <Card className="NodeAnnualReportCard" {...link && { withLink: true }}>
      <div className="Card__image-wrapper">
        <Card.Image
          image={image}
        />
      </div>
      <Card.Content>
        <Card.Link href={link}>
          <Card.Title title={title} /><Icon name="arrow_outward" flair="outlined" />
        </Card.Link>
      </Card.Content>
    </Card>
  );
};

export default NodeAnnualReportCard;
